const styles = `.devkit-instant-mock-overlay {
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 99999;
  cursor: default;
  overflow-x: hidden;
  overflow-y: scroll;
  font-size: 1.4rem;
  font-family: arial, helvetica, sans-serif;
}

.devkit-instant-mock-overlay::-webkit-scrollbar {
	width: 5px;
	height: 0px;
}

.devkit-instant-mock-closeBtn::before {
  content: "✕";
}

.devkit-instant-mock-closeBtn {
  position: absolute;
  top: 0;
  right: 0;
  width: 50px;
  color: #888;
  font-size: 1.8rem;
  font-weight: bolder;
}

.devkit-instant-mock-context-choose {
  background-color: #fff;
  color: #000;
  border-radius: 6px;
  box-shadow: 0 2px 8px 2px rgba(0,0,0,.5);
  display: block;
  margin: 16px 8px;
  overflow: hidden;
  position: relative;
  font-family: arial;
  padding-bottom: 30px;
  top: 200px;
  opacity: 0;
  transition: top 0.2s ease-out 0s, opacity 0.1s;
}

.devkit-instant-mock-context-choose h1 {
  margin: 0;
  border-bottom: thin solid #dddfe2;
  height: 3.6rem;
  line-height: 3.6rem;
  font-size: 1.8rem;
  position: relative;
  text-align: center;
  font-weight: normal;
}

.devkit-instant-mock-context-choose h2 {
  margin: 20px 0 0 0;
  padding: 5px 17px;
  font-size: 16px;
  background-color: #f5f5f5;
  color: #abaaaa;
  font-weight: lighter;
  text-align: left;
}

.devkit-instant-mock-context-choose-item {
  margin: 20px 0 0 16px;
  align-items: center;
  display: flex;
  outline: none;
  overflow: hidden;
  padding: 0 10px;
  text-align: left;
}

.devkit-instant-mock-context-choose-item-icon {
  width: 50px;
  height: 50px;
  border-radius: 50px;
  background-color: #4d82f7;
  display: inline-block;
  background-size: cover;
}

.devkit-instant-mock-context-choose-item-title {
  display: inline-block;
  flex-grow: 1;
  margin: 0 22px;
}

.devkit-instant-mock-context-choose-item-btn {
  display: inline-block;
  border: solid 1px #4d82f7;
  color: #4d82f7;
  font-size: 14px;
  padding: 6px 12px;
  border-radius: 4px;
  background-color: #fff;
}
.devkit-instant-mock-context-switch {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
}

.devkit-instant-mock-context-switch h1 {
  font-size: 1.1em;
  margin: 16px 0;
}

.devkit-instant-mock-context-switch-box {
  margin: auto 10px;
  background-color: #fff;
  border-radius: 18px;
  box-shadow: 0 2px 8px 2px rgba(0,0,0,.5);
  display: block;
  overflow: hidden;
  position: relative;
  text-align: center;
  padding: 20px;
  padding-top: 30px;
}

.devkit-instant-mock-context-switch-icon {
  width: 80px;
  height: 80px;
  border-radius: 80px;
  background-size: cover;
  background-color: #9dcab1;
  display: inline-block;
  border: solid 4px #fff;
  margin-left: -12px;
}

.devkit-instant-mock-context-switch-btn {
  font-size: 20px;
  width: 150px;
}

/**
Purchase confirmation style
**/
.devkit-instant-mock-purchase-confirmation {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  width: 70%;
  margin: auto;
}

.devkit-instant-mock-purchase-confirmation h1 {
  font-size: 0.8em;
  margin: 16px 0;
}

.devkit-instant-mock-purchase-confirmation h3 {
  font-size: 0.8em;
  margin: 16px 0;
}

.devkit-instant-mock-purchase-confirmation-box {
  margin: auto 10px;
  background-color: #fff;
  border-radius: 18px;
  box-shadow: 0 2px 8px 2px rgba(0,0,0,.5);
  display: block;
  overflow: hidden;
  position: relative;
  text-align: center;
  padding: 20px;
  padding-top: 30px;
}

.devkit-instant-mock-purchase-confirmation-icon {
  width: 80px;
  height: 80px;
  border-radius: 80px;
  background-size: cover;
  background-color: #9dcab1;
  display: inline-block;
  border: solid 4px #fff;
  margin-left: -12px;
}

.devkit-instant-mock-purchase-confirmation-btn {
  font-size: 20px;
  width: 150px;
  display: inline-block;
  border: solid 1px #4d82f7;
  color: #4d82f7;
  font-size: 14px;
  padding: 6px 12px;
  border-radius: 4px;
  background-color: #fff;
}

/**
  MachMakingInfo dialog
**/
.devkit-instant-mock-matchmakingInfo {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  width: 70%;
  margin: auto;
}

.devkit-instant-mock-matchmakingInfo-box {
  margin: auto 10px;
  background-color: #fff;
  border-radius: 18px;
  box-shadow: 0 2px 8px 2px rgba(0,0,0,.5);
  display: block;
  overflow: hidden;
  position: relative;
  text-align: center;
  padding: 20px;
  padding-top: 30px;
  height: 500px;
}

.devkit-instant-mock-matchmakingInfo h1 {
  font-size: 1em;
  margin: 16px 0;
}

.devkit-instant-mock-matchmakingInfo p {
  font-size: 17px;
  margin: 16px 0;
  margin-top: 60px;
  margin-bottom: 60px;
  text-align: justify;
}

.devkit-instant-mock-matchmakingInfo-btn {
  font-size: 17px;
  width: 200px;
  display: inline-block;
  border: solid 1px #4d82f7;
  color: #fff;
  font-size: 17px;
  padding: 10px 12px;
  border-radius: 4px;
  background-color: #4d82f7;
}

/**
  matchmakingSearch dialog
**/
.devkit-instant-mock-matchmakingSearch {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  width: 70%;
  margin: auto;
}

.devkit-instant-mock-matchmakingSearch-box {
  margin: auto 10px;
  background-color: #fff;
  border-radius: 18px;
  box-shadow: 0 2px 8px 2px rgba(0,0,0,.5);
  display: block;
  overflow: hidden;
  position: relative;
  text-align: center;
  padding: 20px;
  padding-top: 30px;
  height: 100px;
}

.devkit-instant-mock-matchmakingSearch h1 {
  font-size: 1em;
  margin: 16px 0;
}

.devkit-instant-mock-matchmakingSearch p {
  font-size: 17px;
  margin: 16px 0;
  margin-top: 60px;
  margin-bottom: 60px;
  text-align: justify;
}

/**
  Share async dialog
**/

.devkit-instant-mock-shareAsync {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 90%;
  width: 92%;
  margin: auto;
}

.devkit-instant-mock-shareAsync-box {
  margin: auto 10px;
  background-color: #fff;
  border-radius: 18px;
  box-shadow: 0 2px 8px 2px rgba(0,0,0,.5);
  display: block;
  overflow: hidden;
  position: relative;
  text-align: center;
  padding: 20px;
  padding-top: 30px;
  height: 720px;
}

.devkit-instant-mock-shareAsync-image {
  display: block;
  width: 100%;
  height: 90%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.devkit-instant-mock-shareAsync-buttons {
  display: flex;
  justify-content: space-between;
  padding: 1rem 0rem;
}

.devkit-instant-mock-shareAsync-button {
  font-size: 1rem;
  border: solid 1px #4d82f7;
  color: #4d82f7;
  text-align: center;
  vertical-align: middle;
  border-radius: 4px;
  height: 100%;
  max-height: 5rem;
  width: 100%;
  min-width: 4rem;
  line-height: 2rem;
  max-width: 6.6rem;
  cursor: pointer;
  transition-duration: 0.4s;
}

.devkit-instant-mock-shareAsync-button:hover {
  background-color: #4d82f7;
  color: #fff;
}

.button-blue {
  background-color: #4d82f7;
  color: #fff;
}

.button-blue:hover {
  background-color: #fff;
  color: #4d82f7;
}

/**
  Share for tournaments
**/

.devkit-instant-mock-shareAsyncTournament {
  color: #000;
  border-radius: 6px;
  display: block;
  margin: 16px 8px;
  overflow: hidden;
  position: relative;
  font-family: arial;
  padding-bottom: 30px;
  top: 10%;
  transition: top 0.2s ease-out 0s, opacity 0.1s;
}

.devkit-instant-mock-shareAsyncTournament-box {
  margin: auto 10px;
  background-color: #fff;
  border-radius: 18px;
  box-shadow: 0 2px 8px 2px rgba(0,0,0,.5);
  display: block;
  overflow: hidden;
  position: relative;
  text-align: center;
  padding: 20px;
  padding-top: 30px;
}

.devkit-instant-mock-shareAsyncTournament-buttons {
  display: flex;
  justify-content: space-between;
  padding: 1rem 0rem;
}

.devkit-instant-mock-shareAsyncTournament-button {
  font-size: 2rem;
  border: solid 1px #4d82f7;
  color: #4d82f7;
  text-align: center;
  vertical-align: middle;
  border-radius: 4px;
  height: 100%;
  max-height: 5rem;
  width: 100%;
  min-width: 5rem;
  line-height: 3rem;
  max-width: 10.6rem;
  cursor: pointer;
  transition-duration: 0.4s;
}

.devkit-instant-mock-shareAsyncTournament-text h1 {
  padding: 50px 0px;
  font-size: 2rem;
  font-weight: bolder;
}

.devkit-instant-mock-shareAsyncTournament-text p {
  padding: 0px 0px 44px 0px;
  font-size: 2rem;
}

.devkit-instant-mock-shareAsyncTournament-button:hover {
  background-color: #4d82f7;
  color: #fff;
}

.button-blue {
  background-color: #4d82f7;
  color: #fff;
}

.button-blue:hover {
  background-color: #fff;
  color: #4d82f7;
}

/**
  Create squad
**/

.devkit-instant-mock-squad-create {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
}

.devkit-instant-mock-squad-create h1 {
  font-size: 1.1em;
  margin: 16px 0;
}

.devkit-instant-mock-squad-create-box {
  margin: auto 10px;
  background-color: #fff;
  border-radius: 18px;
  box-shadow: 0 2px 8px 2px rgba(0,0,0,.5);
  display: block;
  overflow: hidden;
  position: relative;
  text-align: center;
  padding: 20px;
  padding-top: 30px;
}

.devkit-instant-mock-squad-create-buttons {
  display: flex;
  justify-content: space-between;
  padding: 1rem 0rem;
}

.devkit-instant-mock-squad-create-button-cancel {
  font-size: 1rem;
  border: solid 1px #4d82f7;
  color: #4d82f7;
  text-align: center;
  vertical-align: middle;
  border-radius: 4px;
  height: 100%;
  max-height: 5rem;
  width: 100%;
  min-width: 4rem;
  line-height: 2rem;
  max-width: 6.6rem;
  cursor: pointer;
  transition-duration: 0.4s;
}

.devkit-instant-mock-squad-create-button-cancel:hover {
  background-color: #4d82f7;
  color: #fff;
}

.devkit-instant-mock-squad-create-button-confirm {
  font-size: 1rem;
  border: solid 1px #4d82f7;
  background-color: #4d82f7;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  border-radius: 4px;
  height: 100%;
  max-height: 5rem;
  width: 100%;
  min-width: 4rem;
  line-height: 2rem;
  max-width: 6.6rem;
  cursor: pointer;
  transition-duration: 0.4s;
}

.devkit-instant-mock-squad-create-button-confirm:hover {
  background-color: #fff;
  color: #4d82f7;
}

/**
  Join squad
**/

.devkit-instant-mock-squad-join {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
}

.devkit-instant-mock-squad-join h1 {
  font-size: 1.1em;
  margin: 16px 0;
}

.devkit-instant-mock-squad-join-box {
  margin: auto 10px;
  background-color: #fff;
  border-radius: 18px;
  box-shadow: 0 2px 8px 2px rgba(0,0,0,.5);
  display: block;
  overflow: hidden;
  position: relative;
  text-align: center;
  padding: 20px;
  padding-top: 30px;
}

.devkit-instant-mock-squad-join-icon {
  width: 80px;
  height: 80px;
  border-radius: 80px;
  background-size: cover;
  background-color: #9dcab1;
  display: inline-block;
  border: solid 4px #fff;
  margin-left: -12px;
}

.devkit-instant-mock-squad-join-buttons {
  display: flex;
  justify-content: space-between;
  padding: 1rem 0rem;
}

.devkit-instant-mock-squad-join-button-cancel {
  font-size: 1rem;
  border: solid 1px #4d82f7;
  color: #4d82f7;
  text-align: center;
  vertical-align: middle;
  border-radius: 4px;
  height: 100%;
  max-height: 5rem;
  width: 100%;
  min-width: 4rem;
  line-height: 2rem;
  max-width: 6.6rem;
  cursor: pointer;
  transition-duration: 0.4s;
}

.devkit-instant-mock-squad-join-button-cancel:hover {
  background-color: #4d82f7;
  color: #fff;
}

.devkit-instant-mock-squad-join-button-confirm {
  font-size: 1rem;
  border: solid 1px #4d82f7;
  background-color: #4d82f7;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  border-radius: 4px;
  height: 100%;
  max-height: 5rem;
  width: 100%;
  min-width: 4rem;
  line-height: 2rem;
  max-width: 6.6rem;
  cursor: pointer;
  transition-duration: 0.4s;
}

.devkit-instant-mock-squad-join-button-confirm:hover {
  background-color: #fff;
  color: #4d82f7;
}`;
export {
  styles as default
};
